module.exports = {
  "video-player": "_video-player_1pofx_1",
  "video-player--extra-small": "_video-player--extra-small_1pofx_1",
  "video-player--small": "_video-player--small_1pofx_1",
  "video-player--medium": "_video-player--medium_1pofx_1",
  "video-player--large": "_video-player--large_1pofx_1",
  "video-player--touch": "_video-player--touch_1pofx_1",
  "video-player--16-9": "_video-player--16-9_1pofx_1",
  "video-player--9-16": "_video-player--9-16_1pofx_1",
  "video-player--square": "_video-player--square_1pofx_1",
  "video-player__video": "_video-player__video_1pofx_1",
  "video-player__inner": "_video-player__inner_1pofx_1",
  "ui-container": "_ui-container_1pofx_1",
  "ui-container__top": "_ui-container__top_1pofx_1",
  "ui-container__bottom": "_ui-container__bottom_1pofx_1",
  "ui-container__left": "_ui-container__left_1pofx_1",
  "ui-container__right": "_ui-container__right_1pofx_1",
  "breakpoint-observer": "_breakpoint-observer_1pofx_1",
  "ui-container--visible": "_ui-container--visible_1pofx_1",
  "ui-container--simple": "_ui-container--simple_1pofx_1",
  "fullscreen-button": "_fullscreen-button_1pofx_1",
  "play-pause-button": "_play-pause-button_1pofx_1",
  "play-pause-button--centered": "_play-pause-button--centered_1pofx_1",
  "play-pause-button--is-hidden": "_play-pause-button--is-hidden_1pofx_1",
  "play-pause-button-simple": "_play-pause-button-simple_1pofx_1",
  "play-pause-button-simple--loaded": "_play-pause-button-simple--loaded_1pofx_1",
  "play-pause-buttom-simple__text": "_play-pause-buttom-simple__text_1pofx_1",
  "text-grow": "_text-grow_1pofx_1",
  "volume-control": "_volume-control_1pofx_1",
  "volume-button": "_volume-button_1pofx_1",
  "slider": "_slider_1pofx_1",
  "slider__progress-bar": "_slider__progress-bar_1pofx_1",
  "slider__hover-bar": "_slider__hover-bar_1pofx_1",
  "slider__tick": "_slider__tick_1pofx_1",
  "slider--vertical": "_slider--vertical_1pofx_1",
  "slider--dimmed": "_slider--dimmed_1pofx_1",
  "slider__progress-bar__total": "_slider__progress-bar__total_1pofx_1",
  "slider--horizontal": "_slider--horizontal_1pofx_1",
  "slider--hover": "_slider--hover_1pofx_1",
  "slider__progress-bar__progress": "_slider__progress-bar__progress_1pofx_1",
  "slider--hover-backward": "_slider--hover-backward_1pofx_1",
  "slider--dragging": "_slider--dragging_1pofx_1",
  "start-muted-button": "_start-muted-button_1pofx_1",
  "time-indicator": "_time-indicator_1pofx_1",
  "timeline": "_timeline_1pofx_1",
  "timeline--live": "_timeline--live_1pofx_1",
  "timeline__badge": "_timeline__badge_1pofx_1",
  "badgeIn": "_badgeIn_1pofx_1",
  "badgeArrowIn": "_badgeArrowIn_1pofx_1",
  "timeline__badge--live": "_timeline__badge--live_1pofx_1",
  "timeline__badge--time": "_timeline__badge--time_1pofx_1",
  "poster": "_poster_1pofx_1",
  "poster--is-hidden": "_poster--is-hidden_1pofx_1",
  "poster__content": "_poster__content_1pofx_1",
  "image": "_image_1pofx_1",
  "image--is-loaded": "_image--is-loaded_1pofx_1",
  "image--is-hidden": "_image--is-hidden_1pofx_1",
  "loader": "_loader_1pofx_1",
  "pulse": "_pulse_1pofx_1",
  "loader--is-visible": "_loader--is-visible_1pofx_1",
  "error": "_error_1pofx_1",
  "error__message": "_error__message_1pofx_1",
  "error__icon": "_error__icon_1pofx_1",
  "error__header": "_error__header_1pofx_1",
  "error__text": "_error__text_1pofx_1",
  "error__link": "_error__link_1pofx_1",
  "viewport": "_viewport_1pofx_1",
  "live": "_live_1pofx_1",
  "live__left": "_live__left_1pofx_1",
  "live__right": "_live__right_1pofx_1",
  "live__header": "_live__header_1pofx_1",
  "live__divider": "_live__divider_1pofx_1",
  "divider_animation": "_divider_animation_1pofx_1",
  "live__start-time": "_live__start-time_1pofx_1",
  "live__time-left": "_live__time-left_1pofx_1",
  "live__poster": "_live__poster_1pofx_1",
  "live__splash": "_live__splash_1pofx_1",
  "live-splash-appear": "_live-splash-appear_1pofx_1"
};